import { QTD_DEPENDENTES_ENUM } from '../helpers/funcoesPadroes';

const _sessentaCincoAnos = 65;
const _posicaoZeroArray = 0;

const _idadeMaiorQue65 = idade => idade >= _sessentaCincoAnos;

export const validatorPossui2Dependentes65anos = (dependentes, valoresForm, idadeAssociado) => {
    const arrayDeValidacoes = [
        _idadeMaiorQue65(valoresForm.Idade),
        calcularQuantidadeDependentes65anos(dependentes, idadeAssociado)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const calcularQuantidadeDependentes65anos = ((dependentes, idadeAssociado) => {
    let qtdDependentes = dependentes.filter(dep => dep.Idade >= _sessentaCincoAnos).length;

    if (idadeAssociado >= _sessentaCincoAnos) {
        qtdDependentes = qtdDependentes + QTD_DEPENDENTES_ENUM.um;
    }

    return qtdDependentes === QTD_DEPENDENTES_ENUM.dois ? true : false;
});

const parentescos = {
    '01': 'PAI',
    '02': 'MAE',
    '5': 'FILHO(A)',
    '15': 'SOGRO(A)',
    '50': 'FILHO(A) ADOTIVO',
    '20007': 'MADRASTA',
    '20008': 'PADRASTO'
};

export const retornaLabelDoValorParentesco = valueParentesco => {
    const parentesco = valueParentesco.trim();

    if (parentesco === '15') {
        return `Só é permitido dois dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    } else if (parentesco === '03') {
        return 'O Tipo de dependente não pertence ao plano selecionado.';
    }

    return `Só é permitido um dependente do tipo  ${parentescos[`${parentesco}`]}`;
};

export const validatorParentescoEmDuplicidade = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificaSeJaPossuiParentescoSelecionado(dependentes, valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificaSeJaPossuiParentescoSelecionado = (dependentes, values) => {
    const seq = values.Seq;
    const parentesco = values.Parentesco;

    if (!parentesco) {
        return false;
    }

    const parentescosQuePodemSerMaisQueUm =
        ['5', '50', '03', '07', '10006', '10016', '22', '12', '20', '19', '24', 'AVô'];

    if (parentescosQuePodemSerMaisQueUm.includes(parentesco.trim())) {
        return false;
    }

    const possuiParentescoSelecionado =
        dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === parentesco.trim());

    if (!possuiParentescoSelecionado.length) {
        return false;
    }

    if (seq) {
        return seq !== possuiParentescoSelecionado[_posicaoZeroArray].Seq;
    }

    return true;
};